import React from "react";
import { STATUS_META } from "@/lib/constants";

export default function StatusBadge({ status }) {
  const meta = STATUS_META[status] || STATUS_META.assigned;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-semibold whitespace-nowrap"
      style={{ background: `${meta.color}1A`, color: meta.color }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: meta.color }} />
      {meta.label}
    </span>
  );
}
